import renderSwapComponent from '../../../../../pages/vip/features/dynamic-component-wrapper/render-swap-component';

export default renderSwapComponent;
